// Locked's session in this tab: the token unlocking it handed out, and when it reseals unless it is
// used again.
//
// Held in memory and nowhere else, so reloading or closing the tab is enough to seal Locked there,
// and no other tab ever sees it. Every request carries the token while there is one (see the auth
// link), and the API keeps Locked open for another interval each time one of them touches it; the
// requests that can are named in LOCKED_OPERATIONS, so the countdown here starts over with them.
// The API is the one that decides, though: when it says Locked is sealed, it is sealed here too,
// whatever the countdown said.
//
// Like authTools, this is a store for useSyncExternalStore, with a snapshot that only changes when
// something in it does.
const listeners = new Set()

const SEALED = {token: null, resealAfter: 0, relocksAt: null}

export const LOCKED_OPERATIONS = new Set([
  'Locked',
  'CreateFolder',
  'CreateUploadPresigner',
  'CreateDownloadPresigner',
  'DownloadPresigner',
  'ExtendDownload',
  'Upload',
  'UploadDetails',
  'MoveItems',
  'TrashItems',
  'RestoreItems',
  'PurgeItems',
  'UpdateLockedSettings',
  'ChangePassphrase'
])

let snapshot = SEALED

const publish = next => {
  snapshot = next
  listeners.forEach(listener => listener())
}

const relocksAt = resealAfter => Date.now() + resealAfter * 1000

export const getLockedToken = () => snapshot.token

/** Opens Locked in this tab with what unlocking handed back. */
export const openLocked = ({token, resealAfter}) => publish({token, resealAfter, relocksAt: relocksAt(resealAfter)})

/** Starts the interval over, as the API has just done. */
export const touchLocked = () => {
  if (snapshot.token) publish({...snapshot, relocksAt: relocksAt(snapshot.resealAfter)})
}

/** For a new interval chosen in the settings, which the API starts straight away. */
export const changeResealAfter = resealAfter => {
  if (snapshot.token) publish({...snapshot, resealAfter, relocksAt: relocksAt(resealAfter)})
}

export const sealLocked = () => {
  if (snapshot.token) publish(SEALED)
}

export const subscribeLocked = listener => {
  listeners.add(listener)

  return () => listeners.delete(listener)
}

export const getLockedSnapshot = () => snapshot
